import React from "react";
import { Helmet } from "react-helmet";
import { FormattedMessage, useIntl } from "react-intl";
import { MissionInviteMember } from "components/Missions";
import { ApplicantListLayout, ApplicantSelectedCount } from "components/Missions/Applicants";
import PageTitle from "components/PageTitle";
import { Grid } from "components/Containers";
import { APPLICANT_LIST_COLUMNS } from "constants/index";

/**
 * Candidates Page
 */
const Candidates = () => {
  const intl = useIntl();

  return (
    <>
      <Helmet>
        <title>{intl.formatMessage({ id: "Meta.Missions.Applicants.Title" })}</title>
      </Helmet>
      <Grid>
        <Grid.col start={1} end={13}>
          <PageTitle
            subtitle={<FormattedMessage id={`Missions.Applicants.H1`} />}
            actionBar={<MissionInviteMember />}
          />
        </Grid.col>
        <Grid.col start={1} end={13}>
          <ApplicantListLayout
            showAdvancedOptions={true}
            hideOrganizationFilter={false}
            hideMissionFilter={false}
            hideFilters={false}
            hideTabs={true}
            hideMemberFilter={false}
            hideSorts={false}
            hideKeywordSearch={false}
            hideAdvancedFilters={false}
            columns={[
              APPLICANT_LIST_COLUMNS.memberWithDisciplines,
              APPLICANT_LIST_COLUMNS.status,
              APPLICANT_LIST_COLUMNS.checklistPercentage,
              APPLICANT_LIST_COLUMNS.mission,
              APPLICANT_LIST_COLUMNS.location,
              APPLICANT_LIST_COLUMNS.missionStats,
              APPLICANT_LIST_COLUMNS.rate,
              APPLICANT_LIST_COLUMNS.viewButton,
            ]}
            modalConfigFunc={() => ({
              dataFormatted: true,
            })}
            variablesProp={{
              includeFlaggedCommentsCount: true,
            }}
            enableCountQueries={true}
            paginationRightContainer={ApplicantSelectedCount}
          />
        </Grid.col>
      </Grid>
    </>
  );
};

export default Candidates;
